import { DocumentClassV5 } from '../../../../../../api/generated/cz.partners.bank.backofficegateway.documents';
import type { AppSelectOption } from '../../../../../../components/AppSelectComboboxField';
import { useAvailableDocuments } from '../../../../../../components/documents/hooks/useAvailableDocuments';
import { useI18nContext } from '../../../../../../locale/i18n-react';

import { useBankDocumentCategorySelectOptions } from './useBankDocumentCategorySelectOptions';
import { useClientDocumentCategorySelectOptions } from './useClientDocumentCategorySelectOptions';

export const ALL_DOCUMENT_CATEGORIES = 'ALL_DOCUMENT_CATEGORIES';

export const useGetDocumentCategorySelectOptions = (
	documentType: DocumentClassV5,
	clientPidUuid: string,
) => {
	const { LL } = useI18nContext();

	const { bankDocumentTemplates, clientDocumentTemplates, isLoading } =
		useAvailableDocuments({ clientPidUuid });

	const bankCategoryOptions = useBankDocumentCategorySelectOptions(
		bankDocumentTemplates,
	);
	const clientCategoryOptions = useClientDocumentCategorySelectOptions(
		clientDocumentTemplates,
	);

	const categoryOptionsMap = {
		[DocumentClassV5.BANK]: bankCategoryOptions,
		[DocumentClassV5.CLIENT]: clientCategoryOptions,
	} as const;

	const categoryOptions = categoryOptionsMap[documentType];

	const allCategoryOptions: AppSelectOption[] = [
		{
			value: ALL_DOCUMENT_CATEGORIES,
			text: LL.clientDocuments.filtersPopoverContent.labels.allCategories(),
		},
		...categoryOptions,
	];

	return { options: allCategoryOptions, isLoading };
};
